import type { Camera } from 'three';

// 2026-10-06：SceneCanvas 相机引用桥（框选展示区域用：屏幕坐标 → 地面 y=0 世界坐标射线求交）
let camera: Camera | null = null;

export const sceneCameraRef = {
  set(c: Camera | null) {
    camera = c;
  },
  get(): Camera | null {
    return camera;
  },
};
